import { Extension } from "@tiptap/core";

const Indent = Extension.create({
  name: "indent",

  addOptions() {
    return {
      types: ["paragraph", "heading"],
      minIndent: 0,
      maxIndent: 10,
      step: 1.25, // cm
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: 0,
            parseHTML: (element) => {
              const indent = element.style.textIndent;
              if (!indent) return 0;

              const value = parseFloat(indent);
              if (!value) return 0;

              let cm = value;
              if (indent.includes("pt")) cm = value / 28.3465;
              else if (indent.includes("px")) cm = value / 37.7953;
              else if (indent.includes("mm")) cm = value / 10;
              else if (indent.includes("in")) cm = value * 2.54;

              const max = this.options.maxIndent * this.options.step;
              const clamped = Math.min(
                Math.max(cm, this.options.minIndent),
                max
              );
              return Math.round(clamped * 100) / 100;
            },
            renderHTML: (attributes) => {
              if (!attributes.indent) return {};
              return { style: `text-indent: ${attributes.indent}cm` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      increaseIndent:
        () =>
        ({ tr, state, dispatch }) => {
          const { selection } = state;
          const { from, to } = selection;

          state.doc.nodesBetween(from, to, (node, pos) => {
            if (this.options.types.includes(node.type.name)) {
              const currentIndent = node.attrs.indent || 0;
              const newIndent = Math.min(
                currentIndent + this.options.step,
                this.options.maxIndent * this.options.step
              );
              if (dispatch) {
                tr.setNodeMarkup(pos, undefined, {
                  ...node.attrs,
                  indent: newIndent,
                });
              }
            }
          });

          return true;
        },

      decreaseIndent:
        () =>
        ({ tr, state, dispatch }) => {
          const { selection } = state;
          const { from, to } = selection;

          state.doc.nodesBetween(from, to, (node, pos) => {
            if (this.options.types.includes(node.type.name)) {
              const currentIndent = node.attrs.indent || 0;
              const newIndent = Math.max(
                currentIndent - this.options.step,
                this.options.minIndent
              );
              if (dispatch) {
                tr.setNodeMarkup(pos, undefined, {
                  ...node.attrs,
                  indent: newIndent,
                });
              }
            }
          });

          return true;
        },
    };
  },
});

export default Indent;
